import React from 'react';
import styles from './MainSingleFormContent.module.scss';

const MainSingleFormContent = (props) => {
  return (
    <div className={styles.root}>
      {props.children}
    </div>
  );
}

export default MainSingleFormContent;